import { render, staticRenderFns } from "./FormCreateResearch.vue?vue&type=template&id=bebde2d8&scoped=true&"
import script from "./FormCreateResearch.vue?vue&type=script&lang=js&"
export * from "./FormCreateResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebde2d8",
  null
  
)

export default component.exports